import { render, staticRenderFns } from "./CombinadoCard.vue?vue&type=template&id=0502dda1&scoped=true&"
import script from "./CombinadoCard.vue?vue&type=script&lang=js&"
export * from "./CombinadoCard.vue?vue&type=script&lang=js&"
import style0 from "./CombinadoCard.vue?vue&type=style&index=0&id=0502dda1&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0502dda1",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VCheckbox,VIcon})
